import type { ReduxAction } from '@app/types';
import { AppState } from '@reducers/rootReducer';

export type NotificationType =
  | 'activity_birthdays'
  | 'activity_reconnects'
  | 'activity_group_reconnects'
  | 'activity_news'
  | 'activity_events'
  | 'include_recent'
  | 'include_recurring_events'
  | 'pre_meeting'
  | 'in_meeting'
  | 'post_meeting'
  | 'clay_contact_user'
  | 'birthdays'
  | 'reconnects'
  | 'weekly_digest'
  | 'daily_brief'
  | 'include_people_without_information'
  | 'resolve_duplicates';
export type EnabledNotifications = Record<NotificationType, boolean>;

export type UserNotificationsState = {
  enabled: EnabledNotifications;
  updating: boolean;
};

const initialUserNotificationsState = {
  enabled: {
    activity_birthdays: false,
    activity_reconnects: false,
    activity_group_reconnects: true,
    activity_news: false,
    activity_events: false,
    include_recent: false,
    include_recurring_events: false,
    pre_meeting: false,
    in_meeting: false,
    post_meeting: false,
    clay_contact_user: false,
    birthdays: false,
    reconnects: false,
    weekly_digest: false,
    daily_brief: false,
    include_people_without_information: false,
    resolve_duplicates: true,
  },
  updating: false,
};

export const selectEnabledNotifications = (state: AppState) => state.user.notifications.enabled;
export const selectUpdatingEnabledNotifications = (state: AppState) =>
  state.user.notifications.updating;

export function userNotificationsReducer(
  state: UserNotificationsState = initialUserNotificationsState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_ENABLED_NOTIFICATIONS_SUCCEEDED':
      return {
        ...state,
        enabled: payload.response,
      };

    case 'UPDATE_ENABLED_NOTIFICATIONS':
      return {
        ...state,
        updating: true,
        enabled: payload.enabledNotifications,
      };

    case 'UPDATE_ENABLED_NOTIFICATIONS_SUCCEEDED':
      return {
        ...state,
        updating: false,
      };

    default:
      return state;
  }
}
